/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { getAccessToken } from '../utils/auth.utils';
import { SysExternalWebUserType } from 'app/shared/enums/sys-application.enum';

@Injectable({
  providedIn: 'root',
})
export class CPGuard implements CanActivate {
  private jwtHelper = new JwtHelperService();

  constructor(private router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = getAccessToken();
    let decodedToken;
    if (token) {
      decodedToken = this.jwtHelper.decodeToken(token);
    }
    if (
      decodedToken &&
      +decodedToken.sysExternalWebUserTypeId &&
      +decodedToken.sysExternalWebUserTypeId === SysExternalWebUserType.SSICSClientPortal
    ) {
      return true;
    } else {
      return this.router.parseUrl('/login');
    }
  }
}
